export default __webpack_public_path__ + "static/media/urumi3.890213dd.webp";